import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { NotificationData } from "@/types";

type SystemNotificationFactory = (notification: Notification) => NotificationData | false;
const context = require.context("./typeIntegration", true, /[a-zA-Z]\.ts/);

export default context.keys().reduce<SystemNotificationFactory[]>((out, key) => {
  const module = context(key);
  out.push(module.default);
  return out;
}, []);
